
import { Component, Mixins } from 'vue-property-decorator';
import { I18nMixin } from '../../mixins';

@Component
export default class WLNewCustomerRatings extends Mixins(I18nMixin) {
  created() {
    this.defaultI18n = {
      baseline: this.$t('components_plugin.rating.baseline'),
      customer_service_of_the_year: this.$t('components_plugin.rating.customer_service_of_the_year'),
      satisfaction_rate: this.$t('components_plugin.rating.satisfaction_rate'),
      title: this.$t('components_plugin.rating.title'),
    };
  }
}
